import React, { useState } from "react";
// redux
import { useSelector } from "react-redux";
// mui
import Switch from "@mui/material/Switch";
// helpers
import fetching from "../../helpers/fetching/fetching";
import fireAlert from "../../helpers/alerts/fireAlert";
// types
import type { UserState } from "../../types/types";

type Props = {
  defaultValue: boolean;
  apiPath: string;
};

const StatusToggler = ({ defaultValue, apiPath }: Props) => {
  const userToken = useSelector((state: UserState) => state.user.userToken);
  const [checked, setChecked] = useState(!defaultValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    fetching(
      apiPath,
      userToken,
      "PUT",
      JSON.stringify({ is_disabled: !e.target.checked }),
      "application/json"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status && typeof data.status == "number") {
          throw data.message;
        }
        fireAlert("تم تعديل حالة العنصر", "success");
      })
      .catch((error) => fireAlert(error?.toString(), "error"));
  };
  return (
    <Switch
      size="small"
      checked={checked}
      onChange={handleChange}
      color="primary"
      inputProps={{ "aria-label": "controlled" }}
    />
  );
};

export default StatusToggler;
